import { Container } from "../../Atoms/Container";
import { GoalsFormTemplate } from "../../Templates/GoalsFormTemplate";
import * as S from "./styles";
import { useGoalsEdite } from "./useGoalsEdite";

export const GoalsEdite = () => {
  const { handleSubmit, meta } = useGoalsEdite();

  return (
    <Container>
      <S.Wrapper>
        <h1>Editar Meta</h1>
        <GoalsFormTemplate data={meta} handleSubmit={handleSubmit} />
      </S.Wrapper>
    </Container>
  );
};
